import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFly = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 15,
			r: 7,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 15,
			r: 3,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 0L17 4.99996H7.00004L12 0Z",
			fill: "currentColor"
		})
	]
});
export default SvgFly;
